// src/components/Toolbar.jsx
import { useNavigate } from "react-router-dom";
import React from "react";

const ACCESS_OPTIONS = [
  { value: "admin", label: "Admin only" },
  { value: "manager", label: "Admin & Manager" },
  { value: "all", label: "All users" }
];

export default function Toolbar({
  undo, redo, canUndo, canRedo, onPublish,
  access, setAccess,
  previewVisible = true,
  onTogglePreview
}) {
  const navigate = useNavigate();

  return (
    <nav
      className="toolbar"
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: 6,
        padding: "8px 12px",
      }}
    >
      {/* Back */}
      <button className="toolbar-btn" onClick={() => navigate(-1)}>◀ Back</button>

      {/* Undo / Redo */}
      <button
        className="toolbar-btn"
        onClick={undo}
        disabled={!canUndo}
        title="Undo"
        aria-label="Undo"
        style={{ minWidth: 36 }}
      >
        ⟲
      </button>
      <button
        className="toolbar-btn"
        onClick={redo}
        disabled={!canRedo}
        title="Redo"
        aria-label="Redo"
        style={{ minWidth: 36 }}
      >
        ⟳
      </button>

      {/* Access dropdown */}
      <label style={{ display: "flex", alignItems: "center", gap: 8 }}>
        Access:
        <select
          value={access}
          onChange={(e) => setAccess?.(e.target.value)}
          className="toolbar-btn"
          style={{ padding: "6px 10px" }}
        >
          {ACCESS_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
      </label>

      {/* Toggle preview */}
      <button
        className="toolbar-btn"
        data-preview-toggle
        onClick={onTogglePreview}
        aria-pressed={previewVisible}
        title={previewVisible ? "Hide mobile preview" : "Show mobile preview"}
      >
        {previewVisible ? "Hide mobile preview" : "Show mobile preview"}
      </button>

      <button
        className="toolbar-btn primary"
        onClick={() => onPublish?.()}
        style={{
          marginLeft: "auto",
          fontWeight: 600,
          padding: "6px 14px",
        }}
      >
        Publish
      </button>

      <div className="toolbar-spacer" />

      <span className="toolbar-status">Unpublished changes saved</span>
    </nav>
  );
}
